import { Alert, Box, Button, Chip, Container, FormControl, InputLabel, LinearProgress, MenuItem, Paper, Select, Skeleton, Snackbar, Stack, Table, TableBody, TableContainer, TableHead, TextField, Typography,ListSubheader } from '@mui/material'
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react'
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import Apercu from './Apercu';
export default function VentesDeleted() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));
      
      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));


    const [Chargement, setChargement] = useState(false);
    const [removeSuccess, setRemoveSuccess] = useState(false);
    const [Progession, setProgession] = useState(false);
    const [valVendeurs, setvalVendeurs] = useState('Tout');
    const [valCamions, setvalCamions] = useState('Tout');
    const [valReglement, setvalReglement] = useState('Tout');
    const [ListVendeur, setListVendeur] = useState([]);
    const [ListCamion, setListCamion] = useState([]);
    const [ListVentes, setListVentes] = useState([]);
    const [showApercu, setShowApercu] = useState(false);
    const [currentVente, setcurrentVente] = useState([]);
    const [Total, setTotal] = useState(0);
    const [ListPreVendeur, setListPreVendeur] = useState([]);

    const userData = useSelector(state => state.userData)
    const id = userData.id;
    const typeCompte = userData.type
    const apitoken = userData.apitoken;
    const apiUrl = process.env.REACT_APP_API_URL;

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const todayDate = `${year}-${month}-${day}`;
  
    const [selectedDate, setSelectedDate] = useState(todayDate);
    const [selectedDate2, setSelectedDate2] = useState(todayDate);

    const navigate = useNavigate();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setRemoveSuccess(false);
      };
    
    function formatDateToFrench(dateString) {
        const date = new Date(dateString);
      
        // Formater la date en "jour/mois/année"
        const formattedDate = date.toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      
        // Formater l'heure en "heures:minutes" sans les secondes
        const formattedTime = date.toLocaleTimeString('fr-FR', {
          hour: '2-digit',
          minute: '2-digit',
        });
      
        return `${formattedDate} à ${formattedTime}`;
      }
      

    const formatDate = (dateString) => {
        const [date] = dateString.split('T');
        const [year, month, day] = date.split('-');
        return `${year}-${month}-${day}`;
      };

    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
      };
      const handleDateChange2 = (event) => {
        setSelectedDate2(event.target.value);
      };

    const handleVendeurChange = (event) => {
        setvalVendeurs(event.target.value);
      };
      const handleCamionChange = (event) => {
        setvalCamions(event.target.value);
      };

      const handleReglementChange = (event) => {
        setvalReglement(event.target.value);
      };

      const toggleApercu = () => {
        setShowApercu(prevState => !prevState);
      };


      const ShowApercu = (vente) => {
        setcurrentVente(vente);
        toggleApercu()
      }

      const getVendeurs=async () => {
        try {
        const response = await axios.post(`${apiUrl}vendeurs/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListVendeur(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    }

            const getPreVendeurs=async () => {
            try {
            const response = await axios.post(`${apiUrl}prevendeurs/${id}/${apitoken}`,
              {
                timeout: 20000,
              }
            );
    
                  const formattedpreVendeur = 
    
            response.data.map(item => ({
              label: `${item.nom}`,
              id: item._id
            }))
          ;
    
            setListPreVendeur(formattedpreVendeur);
            }
         catch (error) {
        //   navigate('/');    
        }
        }

    const getCamions=async () => {
        try {
        const response = await axios.post(`${apiUrl}camions/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListCamion(response.data);
        }
      catch (error) {
      navigate('/');    
      }
      }

      const getVentes=async () => {
        setChargement(true);
        try {
        const response = await axios.post(`${apiUrl}list/deletedventes/${id}/${apitoken}/${selectedDate}/${selectedDate2}`,
          {
            timeout: 20000,
          }
        );
        setListVentes(response.data);
        }
     catch (error) {
      // navigate('/');    
    }
    setChargement(false);
    }    

const calculateSum = (products) => {
  return products.reduce((total, product) => {
    if (product.total === 0) {
      product.total = 0;
    }

    // ✅ Ajouter 0.25% si le règlement est "Espèce" ou "Crédit"
    const montant =
      product.etat === "Espèce" || product.etat === "Crédit"
        ? product.total * 1.0025
        : product.total;

    return total + montant;
  }, 0);
};

    const formatDateToEnglish = (dateString) => {
      const [date] = dateString.split('T');
      return `${date}`;
    };


const exportCSV = () => {

    let listFiltre = [...ListVentes];

    // Filtre vendeur / prévendeur
    if (valVendeurs !== "Tout") {
        listFiltre = listFiltre.filter(
            vente =>
                vente.vendeur?.id === valVendeurs ||
                vente.prevendeur?.id === valVendeurs
        );
    }

    // Filtre camion
    if (valCamions !== "Tout") {
        listFiltre = listFiltre.filter(
            vente => vente.camion?.id === valCamions
        );
    }

    // Filtre règlement
    if (valReglement !== "Tout") {
        listFiltre = listFiltre.filter(
            vente => vente.etat === valReglement
        );
    }

    const rows = [];

    rows.push([
        "ID Vente",
        "Code client",
        "Client",
        "Règlement",
        "Vendeur / Prévendeur",
        "Camion",
        "Secteur",
        "Montant vente",
        "Date",
        "Produit",
        "Packs",
        "Unités"
    ]);

    listFiltre.forEach(vente => {

        const montant =
            vente.etat === "Espèce" ||
            vente.etat === "Crédit"
                ? (vente.total * 1.0025).toFixed(2)
                : vente.total.toFixed(2);

        const produits = (vente.produits || []).filter(
            produit =>
                produit.pack > 0 ||
                produit.unite > 0
        );

        const idVente = vente._id || "";

        const codeClient =
            vente.client?.client_code || "";

        const client =
            `${vente.client?.nom || ""} ${vente.client?.prenom || ""}`.trim();

        const vendeur =
            vente.vendeur?.nom ||
            vente.prevendeur?.nom ||
            "";

        const camion =
            vente.camion?.designation || "";

        const secteur =
            vente.secteur?.designation || "";

        const date =
            vente.date
                ? formatDateToFrench(vente.date)
                : "";

        if (produits.length > 0) {

            produits.forEach(produit => {

                rows.push([
                    idVente,
                    codeClient,
                    client,
                    vente.etat || "",
                    vendeur,
                    camion,
                    secteur,
                    montant,
                    date,
                    produit.designation || "",
                    produit.pack || 0,
                    produit.unite || 0
                ]);

            });

        } else {

            rows.push([
                idVente,
                codeClient,
                client,
                vente.etat || "",
                vendeur,
                camion,
                secteur,
                montant,
                date,
                "",
                0,
                0
            ]);

        }

    });

    const csvContent =
        "\uFEFF" +
        rows
            .map(row =>
                row
                    .map(value =>
                        `"${String(value ?? "").replace(/"/g, '""')}"`
                    )
                    .join(";")
            )
            .join("\r\n");

    const blob = new Blob(
        [csvContent],
        {
            type: "text/csv;charset=utf-8;"
        }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download =
        `Ventes_supprimees_${selectedDate}_${selectedDate2}.csv`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
};

    function ShowList() {
        if(ListVentes.length > 0){
          let listFiltre=ListVentes
          if(valVendeurs!=="Tout") {
            listFiltre = listFiltre.filter(vente => 
                vente.vendeur?.["id"] === valVendeurs || 
                vente.prevendeur?.["id"] === valVendeurs
            )
        }
        if(valCamions!=="Tout") {
          listFiltre = listFiltre.filter(vente => vente.camion["id"] === valCamions)
      }
      if(valReglement!=="Tout") {
        listFiltre = listFiltre.filter(vente => vente.etat === valReglement)
    }
          setTotal(calculateSum(listFiltre))
          return listFiltre.map(Ventes => {
            return(
              <StyledTableRow key={Ventes._id}>
              <StyledTableCell component="th" scope="row">
              <Typography variant="h6"  color="secondary">
            {Ventes.client["nom"]}  {Ventes.client["prenom"]}
            </Typography>
              <Box> {Ventes.client["client_code"]}</Box>
              <Box mt={1}>

                    <Chip label={Ventes.client["categorie"]} variant="outlined" />
                </Box>
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">

              <Box maxWidth={300} sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {Ventes.promotions.map( promo =>{
                  return(
                    <Chip label={promo.nom_promo} variant="outlined" />
                  )
                }

                )
                }
                </Box>

              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.etat}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.vendeur["nom"]}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.camion["designation"]}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.secteur["designation"]}
              </StyledTableCell>
            <StyledTableCell component="th" scope="row">
              {(Ventes.etat === "Espèce" || Ventes.etat === "Crédit" )
                ? (Ventes.total * 1.0025).toFixed(2) 
                : Ventes.total.toFixed(2)} Dhs
            </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Ventes.date!=="" ? formatDateToFrench(Ventes.date) : ''}
              </StyledTableCell>
              <StyledTableCell align="right">
                <Box>
              <Button sx={{ width:'140px' }} variant="outlined" color='secondary' startIcon={<VisibilityIcon />} onClick={() => ShowApercu(Ventes)}>
              Aperçu
              </Button>  
              </Box>
              </StyledTableCell>
            </StyledTableRow>
            )
      
          })
          }
          else {
            return (
              <StyledTableRow>
              <StyledTableCell align='center' colSpan={9} component="th" scope="row">
              Pas de données
              </StyledTableCell>
            </StyledTableRow>
            )
          }
          }

      useEffect(() =>{
        getVentes();
        getVendeurs();
        getPreVendeurs();
        getCamions();
        },[]);


        useEffect(() =>{
          getVentes();
          },[selectedDate,selectedDate2]);

  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>

        <Typography variant="h4" align='center' color="primary">
        Liste des ventes supprimées
        </Typography>

        <Box display="flex" width="100%" mt={5}>
        <Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 160 }}>
          <InputLabel id="demo-simple-select-label">Vendeurs/prévendeurs</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valVendeurs}
          label="Vendeurs/prévendeurs"
          onChange={handleVendeurChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
            <ListSubheader>VENDEURS</ListSubheader>

          {ListVendeur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}

      <ListSubheader>PRÉVENDEURS</ListSubheader>

        {ListPreVendeur.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.label}
          </MenuItem>
        ))}

          </Select>
          </FormControl>
}
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150,marginLeft:2 }}>
          <InputLabel id="demo-simple-select-label">Camions</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valCamions}
          label="Camions"
          onChange={handleCamionChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {ListCamion.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
}
</Box>

<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }} variant="rounded" height={56} width={150} />
         :
         <FormControl sx={{ minWidth: 150,marginLeft:2 }}>
         <InputLabel id="demo-simple-select-label">Réglement</InputLabel>
         <Select
       
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={valReglement}
         label="Réglement"
         onChange={handleReglementChange}
       >
        <MenuItem value='Tout'>Tout</MenuItem>
          <MenuItem value='Espèce'>Espèce</MenuItem>
          <MenuItem value='Chèque'>Chèque</MenuItem>
          <MenuItem value='Crédit'>Crédit</MenuItem>

         </Select>
         </FormControl>

}
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }} variant="rounded" height={56} width={150} />
         :
         <TextField sx={{ marginLeft: 2 }}
         value={selectedDate}
         onChange={handleDateChange}
         id="input-with-icon-textfield"
         label="Du"
         size='normal'
         type='date'
     variant="outlined"
   />  
}
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }} variant="rounded" height={56} width={150} />
         :
         <TextField sx={{ marginLeft: 2 }}
         value={selectedDate2}
         onChange={handleDateChange2}
         id="input-with-icon-textfield"
         label="Au"
         size='normal'
         type='date'
     variant="outlined"
   />  
}
</Box>

           <Box mt={2} style={{ marginLeft: 'auto' }}>

            <Button variant="contained" size='large' color="success" onClick={exportCSV} >
    Exporter CSV
  </Button>
           </Box> 


        </Box>

        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
          
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Client</StyledTableCell>
            <StyledTableCell>Promotion(s)</StyledTableCell>
            <StyledTableCell>Régelement</StyledTableCell>
            <StyledTableCell>Vendeur</StyledTableCell>
            <StyledTableCell>Camion</StyledTableCell>
            <StyledTableCell>Secteur</StyledTableCell>
            <StyledTableCell>Montant</StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell align="right">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
          <StyledTableRow>
              <StyledTableCell align='center' colSpan={9} component="th" scope="row">
              Total : {Total.toFixed(2)} Dhs
              </StyledTableCell>
            </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
    </>
}
<Apercu Show={showApercu} toggleApercu={toggleApercu} currentVente = {currentVente}/>



<Snackbar open={removeSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Vente supprimée avec succès
        </Alert>
      </Snackbar>

    </Container>
  )
}
